import { WEBSOCKET_URL } from '@shared/conf/env';
import { getUser } from '@shared/helpers/auth';
//import { API_URL } from './shared/conf/env';

import { gs } from '@shared/helpers/sgn-min';

const SITE_ID = parseInt(process.env.REACT_APP_SITE_ID || '0', 10);
const isTDH = SITE_ID === 1;

var vthws = {};

window.vthws = vthws;

const sortObj = obj => {
  return Object.keys(obj)
    .sort()
    .reduce((acc, clave) => {
      acc[clave] = obj[clave];
      return acc;
    }, {});
};

vthws.enableAnotherSerch = () => {};

//set configuration of the socket, if the librarie is not loaded, try again in 100 ms
vthws.startSKT = () => {
  vthws.callback = _data => {};

  vthws.sendToTracker = (/*body*/) => {
    /*fetch(API_URL + '/irix-tracker', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        site: SITE_ID,
        ...body,
      }),
    });*/
  };
  try {
    if (window.io) {
      const socket = window.io(
        WEBSOCKET_URL ? WEBSOCKET_URL : 'https://mm3.systemtours.cloud',
        { forceNew: true }
      );
      //const socket = io('wss://main.com2.ar', {forceNew: true});
      socket.on('connect', () => {
        const h = gs('/socket', 'WSS', {});
        const { Signature: sgn, 'Sign-Timestamp': tmstp } = h.headers;
        socket.emit('hi', { sgn, tmstp });
      });
      socket.on('disconnect', () => {
        //console.log('DISCONECTED ' + new Date().toISOString());
      });
      socket.on('search', data => {
        if (!vthws.searching) {
          vthws.search = data;
          if (vthws.searchObject.chosen_airlines == null) {
            vthws.airlines = {
              v: 0,
              airlines: {},
            };
          } else {
            vthws.cheepest = 0;
            vthws.searching = true;
          }
          vthws.go = () => {
            try {
              delete vthws.go;
              vthws.cheepest = 0;
              socket.emit(
                vthws.searchObject.arrayLegs.length == 2
                  ? 'flightBulck'
                  : 'single-flightBulck',
                data
              );
              vthws.searching = true;
              vthws.sendToTracker({
                services: 'Flygth +-3 Started (' + socket.id + ')',
                ...vthws.searchObject,
              });
            } catch (error) {
              console.log(error);
            }
          };
        } else {
          console.log('Posee busqueda activa');
        }
      });
      socket.on('dataResult', data => {
        let newAirlines = false;
        if (data.idFlight !== vthws.search) {
          return null;
        }
        //console.log('resultado recibido');
        if (vthws.searchObject.arrayLegs.length == 2) {
          if (data.i != null && data.j != null) {
            if (!data.obj) {
              data.obj = vthws.results[data.i][data.j];
              data.obj.TotalAmount = '-';
            } else {
              if (data.obj?.TotalAmount && data.obj?.TotalAmount != '-') {
                if (
                  vthws.cheepest == 0 ||
                  data.obj?.TotalAmount < vthws.cheepest
                ) {
                  vthws.cheepest = data.obj?.TotalAmount;
                }
              }
            }
            if (data.i == data.j && data.i == 3) data.obj.today = true;
            vthws.results[data.i][data.j] = data.obj;
          }
        } else if (vthws.searchObject.arrayLegs.length == 1) {
          if (data.i != null)
            if (!data?.obj?.data) {
              data.obj.data = vthws.searchObject.arrayLegs.map(el => {
                return {
                  origen: el.DepartureAirportCity,
                  destino: el.ArrivalAirportCity,
                  horaSalida: data.obj.from + 'T12:00',
                };
              });
            } else {
              if (data.obj?.TotalAmount && data.obj?.TotalAmount != '-') {
                if (
                  vthws.cheepest == 0 ||
                  data.obj?.TotalAmount < vthws.cheepest
                ) {
                  vthws.cheepest = data.obj?.TotalAmount;
                }
              }
            }
          if (data.i == 3) data.obj.today = true;
          vthws.results[data.i] = data.obj;
        }
        try {
          if (vthws.airlines.v < data.airlinesV && data.airlines) {
            vthws.airlines.v = data.airlinesV;
            const filtred = {};
            Object.keys(data.airlines).forEach(el => {
              if (data.airlines[el] != null) filtred[el] = data.airlines[el];
            });
            vthws.airlines.airlines = sortObj(filtred);
            newAirlines = true;
          }
        } catch (error) {
          1;
        }
        delete data.airlinesV;
        if (!newAirlines) delete data.airlines;
        if (data.airlines) delete vthws.airlines.airlines.v; // remove version
        vthws.callback(data);
      });
      socket.on('done', data => {
        try {
          vthws.enableAnotherSerch();

          let someSuccess = false;
          const summary = vthws.results.map(el => {
            if (Array.isArray(el)) {
              return el.map(sub => {
                if (sub.TotalAmount > 0) someSuccess = true;
                return sub.TotalAmount
                  ? parseFloat(sub.TotalAmount.toFixed(2))
                  : 0;
              });
            } else {
              if (el.TotalAmount > 0) someSuccess = true;
              return el.TotalAmount ? parseFloat(el.TotalAmount.toFixed(2)) : 0;
            }
          });
          vthws.sendToTracker({
            services: 'Flygth +-3 done (' + socket.id + ')',
            ...data,
            summary,
            error: someSuccess ? false : true,
          });
        } catch (error) {
          1;
        }
        vthws.searching = false;
      });

      vthws.searchInit = bodyRq => {
        try {
          vthws.searching = false;
          // console.log(
          //   bodyRq.arrayLegs.length == 2 ? 'search' : 'single-search'
          // );
          socket.emit(
            bodyRq.arrayLegs.length == 2 ? 'search' : 'single-search',
            bodyRq
          );

          const nD =
            vthws.searchObject.arrayLegs.length == 2
              ? (date1, date2, x, y) => {
                  const nDate1 = new Date(date1.toISOString());
                  const nDate2 = new Date(date2.toISOString());
                  nDate1.setDate(nDate1.getDate() + x);
                  nDate2.setDate(nDate2.getDate() + y);
                  return {
                    TotalAmount: 0,
                    data: [
                      {
                        horaSalida: nDate1.toISOString(),
                      },
                      {
                        horaSalida: nDate2.toISOString(),
                      },
                    ],
                  };
                }
              : (date, addDay) => {
                  const nDate = new Date(date.toISOString());
                  nDate.setDate(nDate.getDate() + addDay);
                  return {
                    TotalAmount: 0,
                    data: [
                      {
                        horaSalida: nDate.toISOString(),
                      },
                    ],
                  };
                };

          const f = new Date(bodyRq.arrayLegs[0].FlightDate + 'T12:00');
          const f2 = bodyRq.arrayLegs[1]
            ? new Date(bodyRq.arrayLegs[1].FlightDate + 'T12:00')
            : null;
          vthws.results =
            vthws.searchObject.arrayLegs.length == 2
              ? [
                  [
                    nD(f, f2, -3, -3),
                    nD(f, f2, -2, -3),
                    nD(f, f2, -1, -3),
                    nD(f, f2, 0, -3),
                    nD(f, f2, 1, -3),
                    nD(f, f2, 2, -3),
                    nD(f, f2, 3, -3),
                  ],
                  [
                    nD(f, f2, -3, -2),
                    nD(f, f2, -2, -2),
                    nD(f, f2, -1, -2),
                    nD(f, f2, 0, -2),
                    nD(f, f2, 1, -2),
                    nD(f, f2, 2, -2),
                    nD(f, f2, 3, -2),
                  ],
                  [
                    nD(f, f2, -3, -1),
                    nD(f, f2, -2, -1),
                    nD(f, f2, -1, -1),
                    nD(f, f2, 0, -1),
                    nD(f, f2, 1, -1),
                    nD(f, f2, 2, -1),
                    nD(f, f2, 3, -1),
                  ],
                  [
                    nD(f, f2, -3, 0),
                    nD(f, f2, -2, 0),
                    nD(f, f2, -1, 0),
                    nD(f, f2, 0, 0),
                    nD(f, f2, 1, 0),
                    nD(f, f2, 2, 0),
                    nD(f, f2, 3, 0),
                  ],
                  [
                    nD(f, f2, -3, 1),
                    nD(f, f2, -2, 1),
                    nD(f, f2, -1, 1),
                    nD(f, f2, 0, 1),
                    nD(f, f2, 1, 1),
                    nD(f, f2, 2, 1),
                    nD(f, f2, 3, 1),
                  ],
                  [
                    nD(f, f2, -3, 2),
                    nD(f, f2, -2, 2),
                    nD(f, f2, -1, 2),
                    nD(f, f2, 0, 2),
                    nD(f, f2, 1, 2),
                    nD(f, f2, 2, 2),
                    nD(f, f2, 3, 2),
                  ],
                  [
                    nD(f, f2, -3, 3),
                    nD(f, f2, -2, 3),
                    nD(f, f2, -1, 3),
                    nD(f, f2, 0, 3),
                    nD(f, f2, 1, 3),
                    nD(f, f2, 2, 3),
                    nD(f, f2, 3, 3),
                  ],
                ]
              : [
                  nD(f, -3),
                  nD(f, -2),
                  nD(f, -1),
                  nD(f, 0),
                  nD(f, 1),
                  nD(f, 2),
                  nD(f, 3),
                ];

          // console.log('Busqueda iniciada');
        } catch (e) {
          // console.log(e);
        }
      };
    } else {
      setTimeout(() => {
        vthws.startSKT();
      }, 100);
    }
  } catch (e) {
    setTimeout(() => {
      vthws.startSKT();
    }, 100);
  }
};
vthws.startSKT();

vthws.webSerch = body => {
  try {
    let adt = body.adults_qty;
    let chd = 0;
    let inf = 0;
    body.childs.forEach(el => {
      if (el.age < 2) inf++;
      else if (el.age < 12) chd++;
      else adt++;
    });

    let typeG = '';

    const user = getUser();
    if (user && isTDH) {
      typeG = 'B';
    } else if (!user && isTDH) {
      typeG = 'C';
    } else if (user && !isTDH) {
      typeG = 'B';
    } else if (!user && !isTDH) {
      typeG = 'C';
    }

    let chosen_airlines = null;
    if (body.chosen_airlines && body.chosen_airlines.length > 0) {
      chosen_airlines = body.chosen_airlines;
    }

    const objectMM3 = {
      adt,
      chd,
      inf,
      currency: body.is_in_usd ? 'usd' : 'ars',
      mode: typeG, //body.client_glass == 'GIT' ? 'B' : (body.client_glass[body.client_glass.length-1]),
      arrayLegs: [
        ...body.trip_legs.map(el => {
          return {
            DepartureAirportCity: el.origin,
            FlightDate: el.departure_date.replaceAll('/', '-'),
            ArrivalAirportCity: el.destination,
          };
        }),
      ],
      chosen_airlines,
    };
    vthws.searchObject = objectMM3;
    vthws.searchInit(objectMM3);
  } catch (error) {
    //console.log(error);
  }
};
